<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" 
            :title="finalTitle == 'Revisi' ? finalTitle + ' ' + title : title" @back="back">
            <common-training-header />
        </a-page-header>

        <a-row type="flex" style="margin-bottom: 12px">
            <a-col>
                <strong style="font-size: 25px">Peserta</strong>
            </a-col>
        </a-row>

        <a-card type="inner" size="small">

            <a-table :columns="tableColumns" :dataSource="items.attendants" rowKey="hash" :loading="loading" :pagination="false" bordered>

                <div slot="name" slot-scope="record" style="text-align: left">
                    {{ record.name }}
                </div>

                <div slot="count" slot-scope="record" style="text-align: center;">
                    <strong>{{ record.activities[0].files_count }}</strong>
                </div>

                <div slot="presentation_file" slot-scope="record">
                    <div v-if="type == 'Presentasi'">
                        <a-button type="link" size="small" v-if="record.activities[0].files[0] && record.activities[0].presentation_file" @click="download(record.activities[0].presentation_file)">
                            <a-icon type="file-ppt" theme="twoTone" two-tone-color="#eb3437" /> Download
                        </a-button>
                    </div>
                    <div v-else>
                        <a-button type="link" size="small" v-if="record.activities[0].files[0] && record.activities[0].revision_file" @click="download(record.activities[0].revision_file)">
                            <a-icon type="file-ppt" theme="twoTone" two-tone-color="#eb3437" /> Download
                        </a-button>
                    </div>
                </div>

                <div slot="presentation_outline_file" slot-scope="record">
                    <div v-if="type == 'Presentasi'">
                        <a-button type="link" size="small" v-if="record.activities[0].files[0] && record.activities[0].presentation_outline_file" @click="download(record.activities[0].presentation_outline_file)">
                            <a-icon type="file-word" theme="twoTone" two-tone-color="#3452eb" /> Download
                        </a-button>
                    </div>
                    <div v-else>
                        <a-button type="link" size="small" v-if="record.activities[0].files[0] && record.activities[0].revision_outline_file" @click="download(record.activities[0].revision_outline_file)">
                            <a-icon type="file-word" theme="twoTone" two-tone-color="#3452eb" /> Download
                        </a-button>
                    </div>
                </div>

            </a-table>
        </a-card>
    </div>
</template>

<script>
const columns = [
    {
        key: 'name',
        title: 'Nama Peserta',
        align: 'center',
        scopedSlots: {customRender: 'name'},
    }, {
        key: 'file',
        title: 'File',
        align: 'center',
        scopedSlots: {customRender: 'file'},
        children: [
            {
                key: 'presentation_file',
                title: 'Presentasi',
                align: 'center',
                width: '180px',
                scopedSlots: {customRender: 'presentation_file'},
            },
            {
                key: 'presentation_outline_file',
                title: 'Makalah',
                align: 'center',
                width: '180px',
                scopedSlots: {customRender: 'presentation_outline_file'},
            }
        ]
    },
]

export default {
    props: {
        outline: {
            type: String,
            required: true
        },
        hash: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            columns,
            items: {
                outline: {
                    title: ''
                },
                attendants: []
            },
            loading: false,
            processing: false,
        }
    },
    created() {
        this.getItems()
    },
    computed: {
        activeModule() {
            return this.$laravel.active_module
        },
        finalTitle(){
            return this.type
        },
        title(){
            switch(this.outline) {
                case "proposal":
                    return "Presentasi & Proposal"
                case "project_evaluation":
                    return "Presentasi & Evaluasi Project"
                default:
                    return "Presentasi & Makalah"
            }
        },
        outlineColumn(){
            switch(this.outline) {
                case "proposal":
                    return "Proposal"
                case "project_evaluation":
                    return "Evaluasi Project"
                default:
                    return "Makalah"
            }
        },
        tableColumns() {
            if(this.finalTitle == 'Revisi' ){
                this.columns[1].children[0].title = 'Revisi Presentasi'
                this.columns[1].children[1].title = 'Revisi ' + this.outlineColumn
            }else{
                this.columns[1].children[0].title = this.finalTitle
                this.columns[1].children[1].title = this.outlineColumn
            }
            
            return this.columns
        },
        role(){
            return this.$laravel.roles[this.activeModule.module.identifier]
        },
        isMentor() {
            return this.role == 'mentor'
        }
    },
    methods: {
        getItems() {
            this.loading = true

            let params = this.activeModule.module.identifier == 'paper' ? null : {
                params: {
                    outline: this.outline
                }
            }

            this.$http
                .get(this.routeUri("api.activity.guidance.attendants", { outline: this.hash }), params)
                .then(response => this.items = response.data)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false))
        },
        download(url) {
            window.open(window.location.origin + url, '_blank')
        },
        handleSuccessResponse(data) {
            let successMessage = "Data berhasil diproses!"

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });
            setTimeout(() => location.reload(), 2000);
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    })
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                })
            }
        },
        back() {
            if(this.outline == 'paper'){
                window.location.href = this.routeUri('admin.' + this.activeModule.module.identifier + '.guidance.summary')
            }else{
                window.location.href = this.routeUri('admin.' + this.activeModule.module.identifier + '.guidance.' + this.outline + '.summary')
            }
        },
    }
}
</script>
